import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AlertService, UserService } from '../_services/index';
import { Observable } from 'rxjs/Observable';
import * as _ from 'underscore';
import * as GlobalVariables from '../sdg/globals/globals';

@Component({
    moduleId: module.id.toString(),
    templateUrl: 'register.component.html',
    styleUrls: ['./register.component.css']
})

export class RegisterComponent {
    model: any = {};
    loading = false;
    teams$: Observable<Object[]>;
    teamlist: Array<Object>=[];
    rolelist: Array<Object>=[];
    lang = 1;
    translation: any;

    constructor(
        private router: Router,
        private userService: UserService,
        private alertService: AlertService) { }

    ngOnInit() {
      this.lang = GlobalVariables.findTranslationOptionsIndex(window);
      this.translation = GlobalVariables.option_translations[this.lang];
      this.rolelist = [{ id: 1, name: this.translation['National Team Member'] }, { id: 2, name: this.translation['Generic User'] }];
      //this.rolelist = [{id:2,name:'Generic User'}];
      this.teams$ = this.userService.getTeams();
      this.teams$
      .subscribe(
          data => {
          //this.teamlist = data;
          this.teamlist = _.sortBy(data, 'name');
          });
    }

    register() {
        this.loading = true;
        // if(this.model.role == 2)
        // delete this.model.team;
        this.userService.create(this.model).subscribe( data => {
            this.alertService.success('Registration successful', true);
            this.router.navigate(['/login']);
        },
        error => {
          debugger;
            var msg='Something went wrong, please try again.', svc = this.alertService;
            if (error.error['username']){
              // var msgcount = error.error['username'].length;
              error.error['username'].forEach(function(err){
                msg = msg + err + '\n';
                // msgcount--;
              //   if(msgcount==0)
              //     svc.error(msg);
              });
            }
            else if (error.error['password']){
              error.error['password'].forEach(function(err){
                msg = msg + err + '\n';
              });
            }

            svc.error(msg);
            this.loading = false;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/register/register.component.ts